export const DataHomeQuestions = [
  {
    q: "What is a .gold domain name extension?",
    a: "A .gold domain name extension is a top-level domain (TLD) representing prestige, trust, and exclusivity - ideal for gold-related, luxury, or high-value brands seeking a premium digital identity.",
  },
  {
    q: "What is a domain marketplace?",
    a: "A domain marketplace is a platform where verified sellers list premium domains for sale. Buyers can explore, compare, and instantly purchase or make offers on domains that match their brand vision.",
  },
  {
    q: "Why should I buy a .gold domain name?",
    a: "Owning a .gold domain builds instant credibility and brand value. It helps you stand out in the global luxury and gold-based industry with a memorable and high-impact online presence.",
  },
  {
    q: "What is the eligibility to purchase a .gold domain name?",
    a: "To purchase a .gold domain, simply register on our platform, complete KYC verification, and agree to our terms. Once verified, you can buy or make offers on premium .gold domains instantly.",
  },
  {
    q: "Can I still join exclusive auctions for rare .gold domains?",
    a: "Yes. While most domains are available for direct purchase, select premium names are offered through limited-time auctions. Verified users will receive early access notifications to participate.",
  },
];

export const DataAuctionAppraisalsQuestions = [
  {
    q: "What makes a great .gold domain?",
    a: "The best .gold domains are short, memorable, and brandable. One to two words that clearly connect to the gold, luxury, or finance sectors perform best in digital visibility and recall.",
  },
  {
    q: "How do I use .Gold domain valuation?",
    a: "Domain valuation helps you understand the worth of your domain based on demand, keyword strength, and branding potential. Use it to set a fair price or make informed buying decisions.",
  },
  {
    q: "Can .Gold Marketplace evaluate my full domain portfolio?",
    a: "Yes, .Gold Marketplace can analyze and appraise entire portfolios. You’ll be notified if you own high-value domains suitable for resale, renewal, or investment opportunities.",
  },
  {
    q: "What is .Gold Domain Valuation?",
    a: ".Gold Domain Valuation uses data models and AI to estimate the potential value of a domain name by analyzing word combinations, market trends, and historical sales data.",
  },
];

export const DataFeaturedQuestions = [
  {
    q: "What if my .gold domain does not sell immediately?",
    a: "Your domain remains listed on the marketplace until sold. You can adjust pricing, enhance visibility with premium listing options, or hold it as an appreciating digital asset.",
  },
  {
    q: "What happens if a buyer makes no offer?",
    a: "If no offer is received, you can relist or reposition your domain for better visibility. The .Gold Marketplace team can assist with pricing guidance and promotional opportunities.",
  },
  {
    q: "Can a buyer cancel a purchase?",
    a: "Buyers can request cancellation before payment confirmation. Once a sale is finalized and payment is processed, ownership transfer begins and the sale becomes binding.",
  },
  {
    q: "What is a reserve price in .gold listings?",
    a: "A reserve price is the minimum amount a seller is willing to accept for a domain. It ensures that domains are not sold below their fair market value.",
  },
];

export const DataPostQuestions = [
  {
    q: "What happens after I buy a domain?",
    a: "Once your payment is confirmed, the .Gold Marketplace initiates a secure ownership transfer to your registered account. You’ll receive full access within 24–48 hours.",
  },
  {
    q: "How can I list my domain on .Gold Marketplace?",
    a: "Register on our platform, complete your KYC, and access the Sell Domains section. Upload your domain details, set a price or accept offers, and publish your listing instantly.",
  },
  {
    q: "Can I still participate in special .gold Domain Marketplace?",
    a: "Yes. The marketplace occasionally runs exclusive auctions for rare .gold domains. Verified sellers and buyers will be notified in advance to join these limited events.",
  },
  {
    q: "What verification is needed to sell or buy?",
    a: "All users must complete KYC verification to ensure secure transactions. This protects both buyers and sellers from fraud and ensures smooth domain transfers.",
  },
];

export const DataSupportQuestions = [
  {
    q: "How can I retrieve my login details?",
    a: "Enter your registered name or email on the login page to receive a security code. Use the link in your email to reset your password — valid for 6 hours.",
  },
  {
    q: "What services does .Gold Marketplace offer?",
    a: ".Gold Marketplace is a one-stop platform for buying, selling, and managing premium domains. Services include domain appraisals, brokerage support, portfolio management, and digital brand consulting.",
  },
  {
    q: "Where can I find my credit card’s security number?",
    a: 'The three-digit code on the back of your Visa or MasterCard — known as a "CVV" — helps verify your card for secure payments on the platform.',
  },
  {
    q: "What happens to my deposit after a premium purchase?",
    a: "Any security deposit made for premium access or early listings remains in your account wallet and can be withdrawn or applied to your next purchase anytime.",
  },
];

export const DataSellDomainsQuestions = [
  {
    q: "How can I retrieve my login details?",
    a: "Enter your registered name or email on the login page to receive a verification code. Use it to reset your password and access your account within minutes.",
  },
  {
    q: "What services does .Gold Marketplace offer sellers?",
    a: ".Gold Marketplace helps sellers list, promote, and sell their premium domains globally. You can also request appraisals, featured placement, and brokerage assistance.",
  },
  {
    q: "Where can I find my credit card’s security number?",
    a: 'The three-digit code on the back of your Visa or MasterCard — the "CVV" — is used for secure online transactions.',
  },
  {
    q: "What happens to my deposit after listing?",
    a: "If you made a deposit as part of your Premium Seller setup, the funds remain in your wallet. You can withdraw or reuse them for renewals or listing upgrades anytime.",
  },
];

export const DataBrokerageServiceQuestions = [
  {
    q: "Why choose our brokerage services?",
    a: "We offer expert negotiation, verified buyers, and personalized service to help you achieve the best market value for your domain.",
  },
  {
    q: "How do I sell my domain through your brokerage?",
    a: "Submit your domain for evaluation. Our team markets it globally and manages all buyer communications and negotiations on your behalf.",
  },
  {
    q: "What is the process for buying a domain through brokerage?",
    a: "Browse verified domains, submit an offer, and let our team handle negotiations and secure the transaction safely.",
  },
  {
    q: "How do I know my domain will sell at a fair price?",
    a: "We conduct market analysis, comparable sales review, and expert appraisals to ensure you receive fair and accurate pricing.",
  },
];
